/* eslint-disable no-unused-vars */
import { ADD_CAMPAIGN_API_URL,ADMIN_ADD_CAMPAIGN_API_URL } from "../components/Shared/constant";

const AddCampaign = async (accessToken, payload) => {
    const responce = window.axios.post(ADMIN_ADD_CAMPAIGN_API_URL, payload, {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + accessToken,
    }}).then(function (result) {
        return {
          ...result.data,
          status:200
        };
    }).catch(function (result) {
        return {
          ...result?.response?.data,
          status:result?.response?.status
        }
    });
    return responce;
};
  
export default AddCampaign;